import { Component, OnInit, Input } from '@angular/core';
import { MouseEvent } from '@agm/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

interface Marker {
  lat: number;
  lng: number;
}

interface Location {
  latitude: number;
  longitude: number;
  mapType: string;
  zoom: number;
  marker: Marker;
}

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  // animations: [
  //   trigger('viewportAnimation', [
  //     state('initial', style({
  //       opacity: 0.0
  //     })),
  //     state('final', style({
  //       opacity: 1.0
  //     })),
  //     transition('initial=>final', animate('2000ms')),
  //     transition('final=>initial', animate('1000ms'))
  //   ]),
  // ]
})
export class ContactComponent  {

  @Input() header: string;
  @Input() subHeader: string;
  @Input() text: string;

  zoom: number = 15;

  // initial center position for the map
  lat: number = 47.332334;
  lng: number = 9.640956;

  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`)
  }

  mapClicked($event: MouseEvent) {
    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
      draggable: true
    });
  }

  markerDragEnd(m: marker, $event: MouseEvent) {
    console.log('dragEnd', m, $event);
  }

  markers: marker[] = [
	  {
		  lat: 47.3323345,
		  lng: 9.6409566,
		  //label: 'Zeughaus',
		  draggable: true
	  }
  ]

  currentState = 'initial';

  inViewPort(event)
  {
    if(event.visible == true)
    {
      this.currentState = 'final';
    }
    else{
      this.currentState = 'initial';
    }
  }

}

interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable: boolean;
}
